import React from "react";
import clsx from "clsx";

import { EVariantExamsHistory, getVariantsClassNames } from "../helper";
import useStyles from "./styles";

interface IProps {
  title: string;
  content: string;
  className?: string;
  variant?: EVariantExamsHistory;
}

const ExamHistoryNote = (props: IProps) => {
  const { content, title, className, variant } = props;
  const classes = useStyles();
  const { detailsClassName } = getVariantsClassNames(variant);

  return (
    <div className={clsx(className, classes.root, detailsClassName)}>
      <div className={clsx(classes.row, classes.title, detailsClassName)}>
        {title}
      </div>
      <div className={clsx(classes.row, classes.content, detailsClassName)}>
        {content}
      </div>
    </div>
  );
};

export default ExamHistoryNote;
